import React, { useEffect, useState } from 'react'
import { Button, Chip, IconButton, LinearProgress } from '@mui/material'

import PlayCircleIcon from '@mui/icons-material/PlayCircle'
import FolderCopyIcon from '@mui/icons-material/FolderCopy';

const getCookie = require('../utils/getCookie')

const TaskItem = (props) => {
  const { logged } = props

  const { idChamado, tituloChamado, protocoloChamado, Arquivado, usuarioExecutor,
    classificacao, criacaoChamado, status, fkUsuarioSoloicitante, fklogado, categoria
    , setorExecutor, usuarioDemandanteTelefone, usuarioDemandanteEmail, tela, tempoEstimado,
    solicitante, usuarioExector } = props

  const [statusAtividade, setStatus, fkSetorDemandante] = useState('')


  const [mensagem, setMensagem] = useState([])
  // alert(tela)
  const [openLoadingDialog, setOpenLoadingDialog] = useState(false)
  const [openMessageDialog, setOpenMessageDialog] = useState(false)
  const [message, setMessage] = useState('')
  const [areas, setAreas] = useState([])
  const [area, setArea] = useState([])
  const [arquivado, setArquivado] = useState(true)





  const data = new Date(props.criacaoChamado)
  function formDate(data) {
    var day = data.getDate();
    var month = data.getMonth() + 1;
    var year = data.getFullYear();
    var dateFormatted = day + '/' + (month) + '/' + year;
    return dateFormatted
  }
  var date = formDate(data)



  // function carregarMensagem() {
  //   // setOpenLoadingDialog(true)
  //   const token = getCookie('_token_task_manager')
  //   const params = {
  //     headers: {
  //       'Authorization': `Bearer ${token}`
  //     }
  //   }
  //   fetch(`${process.env.REACT_APP_DOMAIN_API}/api/mensagem/?fkAtividade=${idChamado}`, params)
  //     .then(response => {
  //       const { status } = response
  //       response.json().then(data => {
  //         // setOpenLoadingDialog(false)

  //         if (status === 401) {
  //           alert('1111')

  //         } else if (status === 200) {
  //           // alert(JSON.stringify(data.data))
  //           setMensagem(data.data)
  //            alert(JSON.stringify(mensagem))
  //           // alert("3")
  //           // alert(JSON.stringify(data))

  //         }
  //       }).catch(err =>{
  //         alert(err)
  //       })
  //     })
  // }





  // if(protocoloChamado != null){
  //   carregarMensagem()

  // }

  function arquivarAtividade() {
    alert(props.status)




    const token = getCookie('_token_task_manager')
    const params = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        arquivado

      })

    }

    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/atividade/${idChamado}/edit`, params)
      .then(response => {
        const { status } = response
        response.json().then(data => {
          // setOpenLoadingDialog(false)
          if (status === 401) {
            // setMessage(data.message)
            // setOpenMessageDialog(true)
            alert('erro')
          } else if (status === 200) {
            alert('chamado arquivado com sucesso')
            window.location.href = `${process.env.REACT_APP_DOMAIN}/home`


            setMessage(data.message)
            // alert(message)

          }
        }).catch(err => alert(err))
      })




  }

  // function carregarArea() {
  //   setOpenLoadingDialog(true)
  //   const token = getCookie('_token_task_manager')
  //   const params = {
  //     headers: {
  //       'Authorization': `Bearer ${token}`
  //     }
  //   }
  //   fetch(`${process.env.REACT_APP_DOMAIN_API}/api/area/?fkArea=${props.fkSetorDemandante}`, params)
  //     .then(response => {
  //       const { status } = response
  //       response.json().then(data => {
  //         setOpenLoadingDialog(false)
  //         if(status === 401) {  
  //         } else if(status === 200) {
  //           setArea(data.data)
  //         }
  //       }).catch(err => setOpenLoadingDialog(false))
  //     })
  // }
  // useEffect(() => {
  //   carregarArea()
  //   alert(JSON.stringify(area))

  // }, [])


  // setArea(areas.filter(area => area.id === fkSetorDemandante))

  const statusColors = {
    Aberto: "#007bff", // Azul
    Iniciado: "#28a745", // Verde
    Parado: "#ffc107", // Amarelo
    Pendente: "#dc3545", // Vermelho
    Planejado: "#5bc0de", // Azul claro
  };


  const prioridadeColors = {
    Baixa: "#007bff", // Azul
    Media: "#28a745", // Verde
    Alta: "#dc3545", // Amarelo
    Critica: "#c60e3d", // Vermelho
    NaoDefenido: "#5bc0de", // Azul claro
  };

  const StatusButton = ({ status }) => {
    const color = statusColors[status] || "#6c757d"; // Cor padrão (cinza) se o status não estiver definido
    return (
      <button style={buttonStyle(color)}>
        {status}
      </button>
    );
  };

  const PrioridadeButton = ({ status }) => {
    const color = prioridadeColors[status] || "#6c757d"; // Cor padrão (cinza) se o status não estiver definido
    return (
      <button style={buttonStyle2(color)}>
        {"Prioridade " + status}
      </button>
    );
  };

  const buttonStyle = (color) => ({
    backgroundColor: `${color}33`, // Cor com transparência (33 = 20% opacidade)
    color: color, // Texto na cor principal
    borderRadius: "12px", // Forma arredondada
    padding: "4px 10px", // Tamanho ajustado para parecer mais elegante
    fontSize: "12px", // Tamanho de fonte menor
    fontWeight: "500", // Texto semi-negrito
    display: "inline-block", // Para se comportar como uma badge
    textAlign: "center", // Centraliza o texto
    border: `1px solid ${color}77`, // Borda levemente mais escura com transparência
    marginLeft: "5px", // Margem para espaçamento
  });

  const buttonStyle2 = (color) => ({
    backgroundColor: `${color}80`, // Cor com transparência (33 = 20% opacidade)
    color: 'black', // Texto na cor principal
    borderRadius: "12px", // Forma arredondada
    padding: "4px 10px", // Tamanho ajustado para parecer mais elegante
    fontSize: "12px", // Tamanho de fonte menor
    fontWeight: "500", // Texto semi-negrito
    display: "inline-block", // Para se comportar como uma badge
    textAlign: "center", // Centraliza o texto
    border: `1px solid ${color}77`, // Borda levemente mais escura com transparência
    marginLeft: "5px", // Margem para espaçamento
  });








  return (
    // <div style={{
    //   display: 'flex',
    //   flexDirection: 'row',
    //   minHeight: 100,
    //   color: '#424242',
    //   padding: 16
    //   // cursor: 'pointer'
    // }}>
    //   {/* <div style={{ display: 'flex', flexDirection: 'column', paddingRight: 16, borderRight: '1px solid #E0E0E0' }}>
    //     <div style={{ fontSize: 13, fontWeight: 'bold', color: '#424242' }}>09:15</div>
    //     <div style={{ fontSize: 12, color: '#757575' }}>11:00</div>
    //   </div> */}
    //   <div style={{
    //     backgroundColor: '#ffffff',
    //     marginLeft: 16,
    //     padding: 16,
    //     flex: 1,
    //     borderRadius: 45,
    //     boxShadow: '0px 0px 20px -10px #424242',
    //     display: 'flex',
    //     flexDirection: 'column',
    //     border: '1px solid #e0e0e0'
    //   }}>
    //     <div style={{ display: 'flex', flexDirection: 'row' }}>
    //       {/* <div style={{ flex: 1, fontSize: 15, fontWeight: 'bold', color: '#424242', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>Titulo : {props.tituloChamado}</div>

    //       <div>
    //         <IconButton size="small" edge="end" color="inherit">
    //           <MoreIcon />
    //         </IconButton>
    //       </div> */}
    //     </div>
    //     <div style={{ flex: 1, fontSize: 15, wordBreak: "break-all", fontWeight: 'bold', color: '#424242', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    //       Titulo:  {props.tituloChamado}</div>

    //     <div style={{ display: 'flex', flexDirection: 'column', marginTop: 8 }}>








    //       <div style={{ fontSize: 12, fontWeight: 'bold', marginLeft: 5, marginRight: 8, marginBottom: 5, position: 'relative' }}>
    //         <Chip size="small" label={"Protocolo: " + props.protocoloChamado} />
    //       </div>
    //       <div style={{ fontSize: 12, fontWeight: 'bold', marginLeft: 5, marginRight: 8, marginBottom: 5, position: 'relative' }}>
    //         <Chip size="small" label={"Status: " + props.status} />
    //       </div>
    //       {props.categoria != '' ?

    //         <div style={{ fontSize: 12, wordBreak: "break-all", width:'80%', fontWeight: 'bold', marginLeft: 5, marginRight: 8, marginBottom: 5, position: 'relative' }}>
    //           <Chip size="small" label={"Categoria: " + props.categoria} />
    //         </div>

    //         :
    //         ''
    //       }


    //       {props.tempoEstimado != null ?

    //         <div style={{ fontSize: 12, fontWeight: 'bold', marginLeft: 5, marginRight: 8, marginBottom: 5, position: 'relative' }}>
    //           <Chip size="small" label={"Tempo para conclusão apos inicio: " + props.tempoEstimado + '/horas'} />
    //         </div>

    //         :
    //         ''
    //       }













    //     </div>
    //     <div style={{ fontSize: 13, color: '#424242', marginTop: 16 }}>


    //         {/* {tela !== 'minhas' ? <div style={{ flex: 1, fontSize: 12, color: '#424242', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    //         Setor Executor : {props.setorExecutor}</div>: ''}


    //         {tela !== 'minhas' ? <div style={{ flex: 1, fontSize: 12, color: '#424242', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    //         Usuario Executor : {props.usuarioExecutor}</div>: ''} */}



    //       <div style={{ flex: 1, fontSize: 12, color: '#424242', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    //         Abertura : {date}</div>




    //       {tela == 'minhas' ? <div style={{ flex: 1, fontSize: 12, color: '#424242', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    //         Solicitante : {props.usuarioDemandante}</div> : ''}

    //       {tela == 'minhas' ? <div style={{ flex: 1, fontSize: 12, color: '#424242', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    //         Setor : {props.fkSetorDemandante}</div> : ''}





    //       {tela == 'minhas' ? <div style={{ flex: 1, fontSize: 12, color: '#424242', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    //         Email : {props.usuarioDemandanteEmail}</div> : ''}




    //       {tela == 'minhas' ? <div style={{ flex: 1, fontSize: 12, color: '#424242', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    //         Telefone : {props.usuarioDemandanteTelefone}</div> : ''}





    //       <div style={{ flex: 1, fontSize: 12, color: '#424242', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    //         Classificação : {props.classificacao}</div>

    //       {/* <div style={{ flex: 1, fontSize: 12, color: '#424242', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    //         <b>Setor :</b>  {props.setorSolicitante}</div> */}





    //       {props.Arquivado == true
    //         ?
    //         <div style={{ color: 'red' }}>
    //           Chamado arquivado pelo Executor
    //         </div>
    //         :
    //         ''
    //       }











    //     </div>

    //     <div style={{ marginTop: 16, display: 'flex', flexDirection: 'row' }}>
    //       <Button variant="contained" size="small" startIcon={<PlayCircleIcon />} onClick={() => window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${idChamado}/edit`}>
    //         detalhes do chamado
    //       </Button>



    //       {usuarioExecutor === fklogado && Arquivado === false ?

    //         <div style={{ flex: 1, marginLeft: 5 }}>
    //           <Button variant="contained" size="small" startIcon={<FolderCopyIcon />} onClick={() => arquivarAtividade()}>
    //             arquivar
    //           </Button>

    //         </div>
    //         :
    //         ''
    //       }
    //       {/* <LinearProgress color="success" variant="determinate" value={100} /> */}
    //     </div>
    //   </div>

    // </div>

    <div style={{
      display: 'flex',
      flexDirection: 'row',
      minHeight: 100,
      color: '#424242',
      padding: 16
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        marginLeft: 16,
        padding: 16,
        flex: 1,
        borderRadius: 8,
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #e0e0e0',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = '0px 4px 8px rgba(0, 0, 0, 0.2)';
          e.currentTarget.style.transform = 'scale(1.02)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = 'none';
          e.currentTarget.style.transform = 'scale(1)';
        }}>

        <div style={{ display: "flex", gap: "8px" }}>
          <div style={{ marginBottom: "8px" }}>
            <StatusButton status={props.status} />
          </div>

          <div style={{ marginBottom: "8px" }}>
            <PrioridadeButton status={props.classificacao} />
          </div>
        </div>



        <div style={{ fontWeight: 'bold', fontSize: '1.1rem', marginBottom: '8px' }}>
          Título: {props.tituloChamado}
        </div>

        {/* <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
          <StatusButton status={props.status} />
          <PrioridadeButton status={props.classificacao} />
        </div> */}

        <div style={{ marginBottom: '6px', color: '#555' }}>
          <strong>Protocolo:</strong> {props.protocoloChamado}
        </div>
        {/* <div style={{ marginBottom: '6px', color: '#555' }}>
          <strong>Categoria:</strong> {props.categoria || 'Não definida'}
        </div> */}
        {/* <div style={{ marginBottom: '6px', color: '#555' }}>
          <strong>Tempo Estimado:</strong> {props.tempoEstimado ? props.tempoEstimado + ' horas' : 'Não definido'}
        </div> */}

        <div style={{ marginTop: '8px', fontSize: '12px', color: '#007bff', fontWeight: 'bold' }}>
          {props.setorExecutor ? `Setor Executor: ${props.setorExecutor}` : ''}
        </div>
        <div style={{ marginTop: '8px', fontSize: '12px', color: '#007bff', fontWeight: 'bold' }}>
          {props.usuarioExecutor ? `Usuario Executor: ${props.usuarioExecutor}` : 'Executor não definido'}
        </div>



        {props.Arquivado && (
          <div style={{ color: 'red', marginTop: '8px' }}>
            Chamado Arquivado
          </div>
        )}

        <div style={{ marginTop: '16px', display: 'flex', gap: '8px' }}>
          <Button variant="contained" size="small" startIcon={<PlayCircleIcon />} onClick={() => window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${props.idChamado}/edit`}>
            Detalhes
          </Button>
          {props.usuarioExecutor === props.fklogado && !props.Arquivado && (
            <Button variant="contained" size="small" startIcon={<FolderCopyIcon />} onClick={() => arquivarAtividade()}>
              Arquivar
            </Button>
          )}
        </div>
      </div>
    </div>




  )
}

export default TaskItem